import { millisecondsPerHalfHour } from "@/ts/date-time/date-time"

export type SessionData = {
  readonly lastActivity: number
  readonly sessionCount: number
  readonly startTime: number
}

export type SessionCookie = {
  readonly cookieName: "user-session"
  readonly options: {
    readonly expires: number
    readonly path: string
    readonly sameSite: "lax"
    readonly secure: true
  }
  readonly rawSessionCookieData: string
}

export const sessionCookieName = "user-session"

export const sessionTimeout = millisecondsPerHalfHour
